/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:ffd91590-4e2d-431d-9317-d373264a470e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_95PgMxBtw",
    "aws_user_pools_web_client_id": "76bfi0bk009frecd06lpqp3etd",
    "oauth": {
        "domain": "p2-task-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://dev.d1pzyx2hs1s74w.amplifyapp.com/,https://prod.d1pzyx2hs1s74w.amplifyapp.com/,https://p2-task.devfactory.com/",
        "redirectSignOut": "http://localhost:3000/,https://dev.d1pzyx2hs1s74w.amplifyapp.com/,https://prod.d1pzyx2hs1s74w.amplifyapp.com/,https://p2-task.devfactory.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
